import { gql, useMutation, useQuery } from '@apollo/client'

import {
  ArtistUpdateOrganizationNotificationMutation,
  ArtistUpdateOrganizationNotificationMutationVariables,
  ConsoleOfficialInformationEditQuery,
  ConsoleOfficialInformationEditQueryVariables,
  OfficialInformationConsoleBoxFragmentDoc,
} from '@/clients/utoniq-core/schema'
import { useMessage, useRouter, useTranslation } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { useCurrentUser } from '@/core/auth'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { user } = useCurrentUser()
  const { t } = useTranslation('consoleOfficialInformationEdit')
  const { showMessage } = useMessage()
  const { router, routerPages } = useRouter<{ officialInformationId: string }>()

  const { data } = useQuery<
    ConsoleOfficialInformationEditQuery,
    ConsoleOfficialInformationEditQueryVariables
  >(QUERY, { variables: { id: router.query.officialInformationId } })

  const [artistUpdateOrganizationNotification] = useMutation<
    ArtistUpdateOrganizationNotificationMutation,
    ArtistUpdateOrganizationNotificationMutationVariables
  >(UPDATE_ORGANIZATION_NOTIFICATION, {
    onCompleted() {
      showMessage(t('editSuccess'), 'success')
      router.goBack(routerPages.ConsoleOfficialInformations)
    },
  })

  return {
    state: {
      artistId: user?.uid ?? '',
      officialInformation: data?.artistOrganizationNotification ?? null,
    },
    actions: {
      async onSubmit(values) {
        await artistUpdateOrganizationNotification({
          variables: {
            id: router.query.officialInformationId,
            inputs: {
              title: values.title || undefined,
              body: values.body || null,
              link: values.link || null,
            },
          },
        })
      },
    },
  }
})

const QUERY = gql`
  query ConsoleOfficialInformationEdit($id: ID!) {
    artistOrganizationNotification(id: $id) {
      ...OfficialInformationConsoleBox
    }
  }
  ${OfficialInformationConsoleBoxFragmentDoc}
`

const UPDATE_ORGANIZATION_NOTIFICATION = gql`
  mutation ArtistUpdateOrganizationNotification(
    $id: ID!
    $inputs: ArtistUpdateOrganizationNotificationInput!
  ) {
    artistUpdateOrganizationNotification(id: $id, inputs: $inputs) {
      ...OfficialInformationConsoleBox
    }
  }
  ${OfficialInformationConsoleBoxFragmentDoc}
`
